import React from "react";
import { YhBox } from "@/components/YhBox";
import { SearchItem } from "@/components/YhPageHeader/item";
import { Row } from "antd";
import { ISearchField, ISearchProp, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { useAccountModel } from "../account/accountModel";
import { useLogModel } from "./logModel";
import { useDetailModel } from "../detailModel";
import useGlobalModel from "@/model/globalModel";

const logDs = [
    {
        label: '开户',
        value: 'OPEN'
    },
    {
        label: '禁用',
        value: 'DISABLE'
    },
    {
        label: '启用',
        value: 'ENABLE'
    },
    {
        label: '调额',
        value: 'ADJUST'
    },
    {
        label: '调额审核',
        value: 'ADJUST_APPROVAL'
    },
    {
        label: '充值',
        value: 'RECHARGE'
    },
    {
        label: '转入',
        value: 'TRANSFER_IN'
    },
    {
        label: '转出',
        value: 'TRANSFER_OUT'
    },
    {
        label: '平帐',
        value: 'BALANCE'
    },
    {
        label: '更新',
        value: 'UPDATE'
    },
]

export const LogSearchBox = () => {


    const {
        onReset,
        searchParam,
        onSearch,
        updateSearchParam,
        loadData
    } = useLogModel()
    const { customerUserDs } = useDetailModel()
    const { unit } = useGlobalModel()


    const searchProp: ISearchProp = {
        searchValues: searchParam,
        triggerSearch: true,
        handleSearch: (val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val }),
        onChange: (data) => {
            updateSearchParam(data)
        }
    }
    const searchFields: (ISearchProp & ISearchField)[] = [
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "账户名称",
            fieldName: "accountCode",
            size: "small",
            options: customerUserDs?.filter(item => item.unitCode === unit?.code),
            ...searchProp
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "日志类型",
            fieldName: "logType",
            size: "small",
            disabled: false,
            options: logDs,
            ...searchProp
        },
        {
            type: SearchTypeEnum.RangePicker,
            xxl: 8,
            span: 8,
            placeholder: "起止",
            fieldName: "time",
            size: "small",
            disabled: false,
            searchValues: searchParam,
            triggerSearch: true,
            onChange: (data) => {
                let newData = {
                    logTimeRange: data.time[0] !== '' && data.time[1] !== '' ? {
                        startTime: data.time[0] + ' 00:00:00',
                        endTime: data.time[1] + ' 23:59:59'
                    } : undefined,
                    ...data
                }
                updateSearchParam(newData)
                loadData({ pageNum: 1 }, { ...searchParam, ...newData })
            }
        },
        {
            type: SearchTypeEnum.Button,
            xxl: 2,
            span: 2,
            placeholder: "检索",
            fieldName: "searchBtn",
            onClick: onSearch,
        },
        {
            type: SearchTypeEnum.Button,
            xxl: 2,
            span: 2,
            placeholder: "重置",
            fieldName: "resetBtn",
            onClick: onReset,
        },
    ]

    return (
        <YhBox>
            <Row
                gutter={[20, 10]}
                justify="start"
                style={{ padding: "0 15px" }}
            >
                {searchFields?.map(
                    (el, index) => <SearchItem
                        key={index}
                        {...el} />
                )}
            </Row>
        </YhBox>
    )
}
